import PageError, { type PageErrorCode } from './PageError'

export default class PageNotFoundError extends PageError {
  name = 'PageNotFoundError'

  statusCode: PageErrorCode = 404

  constructor(message = 'Oh no! This page does not exist.') {
    super(message)
  }
}
